import { Scale } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';
import { cn } from '@/utils/cn';

export function Disclaimer({ className }: { className?: string }) {
  const { t } = useI18n();
  return (
    <p className={cn('flex items-start gap-2 text-xs leading-relaxed text-zinc-500', className)}>
      <Scale className="mt-0.5 h-3.5 w-3.5 shrink-0 text-zinc-600" aria-hidden />
      <span>{t('footer.disclaimer')}</span>
    </p>
  );
}
